import React, {useEffect, useRef} from 'react';

const CanvasParabola = ({width = 100, height = 100, background = '#fff', dots}) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (canvasRef?.current) {
            const canvas = canvasRef.current;
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');

            ctx.fillStyle = background;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            const startX = 0;
            const endX = canvas.width;

            const curveX = endX / 2;
            const curveY = dots.startY + dots.curve;

            // Draw the curved line
            ctx.beginPath();
            ctx.moveTo(startX, dots.startY);
            ctx.quadraticCurveTo(curveX, curveY, endX, dots.endY);
            ctx.strokeStyle = 'red';
            ctx.stroke();
        }
    }, [canvasRef, dots]);

    return (<canvas
        ref={canvasRef}
    />);
};

export default CanvasParabola;